import Vue from 'vue'

const role = {
    user: 'user',
    tenantAdmin: 'tenant_admin',
    systemAdmin: 'system_admin',
    isRole: function(role){
        return typeof this[role] !== 'undefined';
    }
}

const cookieList = {
    sessionKey: 'session_key',
}

export default ({ app }, inject) => {
    inject('role', role);
    inject('cookieList', cookieList);
}